import { TProductOption } from '../../../../functions/src/shared';

export const formatProductOptions = (options: TProductOption[] | undefined | null) =>
  options ? options.map((o) => o.name).join(' / ') + ': ' : '';
